import { useAppSelector } from "@jidlomat/terminal-core/hooks/utilsHooks/storeHooks";
import { selectShortFridgeId } from "@jidlomat/terminal-core/slices/fridgeInfoSlice";
import { logToSentry } from "@jidlomat/terminal-core/utils/logger";
import { BasicModal } from "@jidlomat/terminal-ui/components/global/modals/BasicModal";
import { ModalSupportFooter } from "@jidlomat/terminal-ui/components/global/modals/ModalSupportFooter";
import { ModalContentWrapper } from "@jidlomat/terminal-ui/components/primitives/ModalContentWrapper";
import { ModalTitle } from "@jidlomat/terminal-ui/components/primitives/ModalTitle";
import { Typography, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import RestrictedModalIllustration from "../../../assets/illustrations/restrictedModalIllustration.svg";

const RestrictedModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();
	const theme = useTheme();

	useEffect(() => {
		logToSentry(`Restricted modal displayed on fridge: ${fridgeId}`, "info");
	}, [fridgeId]);

	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{t("modals.restricted.title")}</ModalTitle>
			<Typography variant="promoText" sx={{ marginRight: "auto", marginBottom: 10 }}>
				{t("modals.restricted.description")}
			</Typography>
			<RestrictedModalIllustration />
			<ModalSupportFooter fridgeId={fridgeId} background={theme.palette.copper.main} />
		</ModalContentWrapper>
	);
};

export const RestrictedModal = () => (
	<BasicModal modalContent={<RestrictedModalContent />} open={true} closable={false} fullHeight={true} />
);
